'use client';

import cn from 'classnames';
import { useLocale } from 'next-intl';
import { Link, usePathname, useRouter } from 'src/navigation';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import styles from './language-list.module.scss';
import { SUPPORTED_LANGUAGES } from 'lib/constants.mjs';

const LanguageList = () => {
	const lang = useLocale();
	const currentLang = lang || 'en';
	const pathname = usePathname();
	const router = useRouter();

	const changeLanguage = (language: string) => {
		pushToDataLayer({
			event: 'select_language',
			language_selected: language,
		});
		router.replace(pathname, { locale: language });
	};

	return (
		<ul className={styles.languageList} data-testid="language-list">
			{SUPPORTED_LANGUAGES.map((lang) => {
				return (
					<li key={lang.id} className={styles.language}>
						<Link
							onNavigate={(e) => {
								e.preventDefault();
								changeLanguage(lang.id);
							}}
							locale={lang.id}
							href={pathname}
							className={cn(styles.languageLink, {
								[styles.active]: lang.id === currentLang,
							})}
						>
							{lang.localName}
						</Link>
					</li>
				);
			})}
		</ul>
	);
};

export default LanguageList;
